import { autoinject } from 'aurelia-framework';
import { Redirect, Router } from 'aurelia-router';
import { DialogHelper } from 'framework/aurelia_dialogs/dialog-helper';
import { ToastFormat, ToastHelper, ToastType } from 'support/toaster';
import { MapZoneDetailModel } from 'model/map-zones';
import { MapZonesController } from './map-zones-controller';

@autoinject
export class MapZonesList {
  constructor(private controller: MapZonesController, private router: Router, private toastHelper: ToastHelper, private dialogHelper: DialogHelper) {
  }

  attached() {
    this.controller.setSplitter();
  }

  detached() {
    this.controller.storeSplitter();
  }

  async bind() {
    await this.controller.search();
  }

  async canDeactivate() {
    if (!(await this.controller.requestMapZoneCancelChanges()))
      return new Redirect((this.router.history as any).previousLocation, { trigger: false, replace: false });
  }

  async archiveMapZone(mapZone: MapZoneDetailModel) {
    await this.controller.archiveMapZone(mapZone);
    this.toastHelper.toast('Zone has been successfully <b>archived</b>.', 'Archived', ToastType.Success, ToastFormat.Html);
  }

  async restoreMapZone(mapZone: MapZoneDetailModel) {
    await this.controller.restoreMapZone(mapZone);
    this.toastHelper.toast('Zone has been successfully <b>restored</b>.', 'Restored', ToastType.Success, ToastFormat.Html);
  }

  async showDetail(mapZone: MapZoneDetailModel) {
    await this.controller.detailMapZone(mapZone);
    return true;
  }

  highlightMapZone(mapZone: MapZoneDetailModel) {
    mapZone.isHighlighted = true;
  }

  unhighlightMapZone(mapZone: MapZoneDetailModel) {
    mapZone.isHighlighted = false;
  }
}
